<script>
    export let layers;
</script>

{#each layers as layer}
    <svelte:component this={layer}/>
{/each}
